/**
 * Logica di calcolo per i pagamenti sidebar
 * Funzioni pure per gestire somme e visibilità dei pagamenti
 */

import { sum, larger } from 'mathjs'

/**
 * Calcola la somma totale dei pagamenti
 * @param {Array} payments - Array di oggetti payment { value, name, type, show }
 * @returns {number} Somma totale dei valori dei pagamenti
 */
export function calculate_payments_sum(payments) {
  if (!payments || payments.length === 0) return 0

  return payments.reduce((accumulator, payment) => {
    return sum(accumulator, payment.value)
  }, 0)
}

/**
 * Determina se il blocco pagamenti deve essere visualizzato
 * Il blocco viene mostrato solo se almeno un metodo di pagamento ha importo > 0
 * @param {Array} payments - Array di oggetti payment
 * @returns {boolean} true se il blocco deve essere mostrato
 */
export function should_show_payments(payments) {
  if (!payments || payments.length === 0) return false

  return payments.some(payment => payment.value > 0)
}

/**
 * Verifica se il credito disponibile è insufficiente a coprire il prezzo
 * @param {number|string} live_price - Prezzo totale
 * @param {number} payments_sum - Somma dei pagamenti disponibili
 * @returns {boolean} true se il credito è insufficiente
 */
export function is_credit_insufficient(live_price, payments_sum) {
  return larger(live_price, payments_sum)
}

/**
 * Filtra i pagamenti da visualizzare (valore > 0 e flag show attivo)
 * @param {Array} payments - Array di oggetti payment
 * @returns {Array} Pagamenti filtrati da visualizzare
 */
export function get_visible_payments(payments) {
  if (!payments || payments.length === 0) return []

  return payments.filter(payment => larger(payment.value, 0) && payment.show)
}